import { differenceInMilliseconds, intervalToDuration } from 'date-fns';

export const formatDate = dateString => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-GB', options);
};

export const formatDateSegments = dateString => {
  const date = new Date(dateString);
  const dayNumber = date.getDate();
  const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  return { dayNumber, dayName, month };
};

export const formatTimeRange = (startAt, endAt) => {
  const options = { hour: 'numeric', minute: 'numeric' };

  const startTime = new Date(startAt).toLocaleTimeString('en-US', options);
  const endTime = new Date(endAt).toLocaleTimeString('en-US', options);

  return `${startTime} - ${endTime}`.toLocaleLowerCase();
};

export const formatTime = dateTime => {
  const options = { hour: 'numeric', minute: 'numeric' };

  const time = new Date(dateTime).toLocaleTimeString('en-US', options);

  return `${time}`.toLocaleLowerCase();
};

export function timeToMinutes(timeStr) {
  const time = new Date(timeStr);
  return time.getHours() * 60 + time.getMinutes();
}

export function formatTimeRemaining(endISODateTime) {
  // Parse the ISO date time string
  const endTime = new Date(endISODateTime);

  // Calculate the time remaining in milliseconds
  const timeRemaining = differenceInMilliseconds(endTime, new Date());

  // Convert milliseconds to hours, minutes, and seconds
  const { hours, minutes, seconds } = intervalToDuration({ start: 0, end: timeRemaining });

  // Format the time remaining
  let formattedTime = '';
  if (hours > 0) {
    formattedTime += hours + 'h';
  }
  if (minutes > 0 || hours > 0) {
    // Include minutes if hours are present
    formattedTime += minutes + 'm';
  }
  if (seconds > 0 || minutes > 0 || hours > 0) {
    // Include seconds if minutes or hours are present
    formattedTime += seconds + 's';
  }

  return formattedTime;
}
